export enum DynamicLinkType {
  EXTERNAL = 0,
  INTERNAL = 1,
  CUSTOM = 2,
}

export enum DynamicLinkError {
  INVALID = 0,
  NOT_FOUND = 1,
}

interface DynamicLinkBase {
  type: DynamicLinkType;
  url: string;
  title?: string;
  error?: DynamicLinkError;
  open?: '_self' | '_blank';
}

export interface DynamicLinkExternal extends DynamicLinkBase {
  type: DynamicLinkType.EXTERNAL;
  url: string;
}

export enum DynamicLinkInternalTarget {
  PAGE = 0,
}

export interface DynamicLinkInternal extends DynamicLinkBase {
  title: string;
  url: string;
  type: DynamicLinkType.INTERNAL;
  target: DynamicLinkInternalTarget;
  targetId: string;
}

export interface DynamicLinkCustom extends DynamicLinkBase {
  title: string;
  type: DynamicLinkType.CUSTOM;
  value: string;
}

export type DynamicLink = DynamicLinkExternal | DynamicLinkInternal | DynamicLinkCustom;
